import React from "react";
import { Image } from "./../../ui-components";
import { ROOT } from "../dataHooks";
import styles from "../statics/styles/giphy-viewer.scss";
const GiphyViewer = (props) => {
  const { componentData } = props;
  const { id, width, height } = componentData;
  if (componentData.original.mp4) {
    return /* @__PURE__ */ React.createElement(
      "video",
      {
        role: "img",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        "aria-label": "gif",
        "data-hook": ROOT,
        className: styles.giphy_player,
        src: componentData.original.mp4
      }
    );
  }
  const isInfoForWixImageReady = id !== void 0 && width !== void 0 && height !== void 0;
  if (isInfoForWixImageReady) {
    return /* @__PURE__ */ React.createElement(
      Image,
      {
        id,
        containerId: `${id}-parent`,
        role: "img",
        "aria-label": "gif",
        height,
        width,
        containerProps: {
          className: styles.gifRatio,
          containerId: `${id}-parent`,
          style: {
            ["--dim-height"]: height,
            ["--dim-width"]: width
          },
          dataHook: ROOT
        },
        displayMode: "fill",
        className: styles.giphy_player,
        uri: componentData.original.gif,
        alt: "gif"
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    "img",
    {
      role: "img",
      "aria-label": "gif",
      className: styles.giphy_player,
      src: componentData.original.gif,
      alt: "gif",
      "data-hook": ROOT
    }
  );
};
var giphy_viewer_default = GiphyViewer;
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer.js.map
